import { Component } from '@angular/core';

@Component({
  selector: 'rr-gender-female',
  templateUrl: './gender-female.component.html',
  styleUrls: ['./gender-female.component.scss'],
})
export class GenderFemaleComponent {
  constructor() {}
}
